import { render } from "./CustomTextarea.vue?vue&type=template&id=9e2939ea&scoped=true"
import script from "./CustomTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&lang=js"

import "./CustomTextarea.vue?vue&type=style&index=0&id=9e2939ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2939ea"]])

export default __exports__